import { DEVICE_TYPE_TRANS, DIRECTION_TRANS, POSITION_TRANS, MMT_GRADE_TRANS } from "@/enum/lib";

export function copyStyles( sourceDoc, targetDoc ) {
    Array.from( sourceDoc.styleSheets ).forEach( styleSheet => {
        if ( styleSheet.cssRules ) {
            // for <style> elements
            const newStyleEl = sourceDoc.createElement( "style" );

            Array.from( styleSheet.cssRules ).forEach( cssRule => {
                // write the text of each rule into the body of the style element
                newStyleEl.appendChild( sourceDoc.createTextNode( cssRule.cssText ) );
            } );

            targetDoc.head.appendChild( newStyleEl );
            targetDoc.body.classList.add( "report_body" );
        } else if ( styleSheet.href ) {
            // for <link> elements loading CSS from a URL
            const newLinkEl = sourceDoc.createElement( "link" );

            newLinkEl.rel = "stylesheet";
            newLinkEl.href = styleSheet.href;
            targetDoc.head.appendChild( newLinkEl );
        }
    } );
}

export const _BASIC_INFO_TABLE = (that) => {
  return [ {
      index: 0,
      keyTitle: that.$t( 'user.name' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 1,
      keyTitle: that.$t( 'patient.info.age' ) + '/' + that.$t( 'patient.info.gender.key' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 2,
      keyTitle: that.$t( 'user.email' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 3,
      keyTitle: that.$t( 'patient.condition.brain_lesions' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 4,
      keyTitle: that.$t( 'patient.condition.on_set_date' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 5,
      keyTitle: that.$t( 'patient.condition.onset_period' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 6,
      keyTitle: that.$t( 'patient.condition.paralysis_part' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 7,
      keyTitle: that.$t( 'patient.condition.primary_diagnosis' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 8,
      keyTitle: that.$t( 'patient.condition.secondary_diagnosis' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }, {
      index: 9,
      keyTitle: that.$t( 'patient.condition.chief_complain' ),
      keyType: 'Default',
      class: [],
      parentClass: [ '' ],
      keyRange: [],
      values: ''
  }];
}

export const _REHABILITATION_TABLE = ( that ) => {
    return [ {
        index: 0,
        keyTitle: that.$t( 'rehabilitation.equipment' ),
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 1,
        keyTitle: that.$t( 'patient.condition.paralysis_part' ),
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 2,
        keyTitle: that.$t( 'rehabilitation.direction' ),
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 3,
        keyTitle: that.$t( 'report.inquiry_period' ),
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 4,
        keyTitle: that.$t( 'patient.measure.first_measurement' ) + '(' + that.$t( 'status.date' ) + ')',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 5,
        keyTitle: 'AROM(DATE_PLACE_IN_HERE)',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 6,
        keyTitle: 'PROM(DATE_PLACE_IN_HERE)',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 7,
        keyTitle: 'MMT(DATE_PLACE_IN_HERE)',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 8,
        keyTitle: that.$t( 'patient.measure.recent_measurement' ) + '(' + that.$t( 'status.date' ) + ')',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 9,
        keyTitle: 'AROM(DATE_PLACE_IN_HERE)',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 10,
        keyTitle: 'PROM(DATE_PLACE_IN_HERE)',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    }, {
        index: 11,
        keyTitle: 'MMT(DATE_PLACE_IN_HERE)',
        keyType: 'Default',
        class: [],
        parentClass: [ '' ],
        keyRange: [],
        values: ''
    } ];
}

export const _TABLE_CREATOR = (() => {

    return {
        createRehabilitationItems :  ( that, inputData ) => {
            const data = new _REHABILITATION_TABLE( that );
            data[0].values = that.$t(DEVICE_TYPE_TRANS[inputData.seqDeviceType].trans);
            data[1].values = that.$t(POSITION_TRANS[inputData.position].trans);
            data[2].values = that.$t(DIRECTION_TRANS[inputData.direction].trans);
            data[3].values = that.moment(inputData.searchDate.start).locale(that.$t('country')).format('ll')
                +' ~ '+ that.moment(inputData.searchDate.end).locale(that.$t('country')).format('ll');
            data[5].keyTitle = that.$t(`unit.aRom.name`)+`(${ that.moment(inputData.initData.aRom.date).locale(that.$t('country')).format('ll') })`;
            data[5].values = inputData.initData.aRom.value+that.$t('unit.deg');
            data[6].keyTitle = that.$t(`unit.pRom.name`)+`(${ that.moment(inputData.initData.pRom.date).locale(that.$t('country')).format('ll') })`;
            data[6].values = inputData.initData.pRom.value+that.$t('unit.deg');
            data[7].keyTitle = that.$t(`unit.MMT.name`)+`(${ that.moment(inputData.initData.MMT.date).locale(that.$t('country')).format('ll') })`;
            data[7].values = that.$t(MMT_GRADE_TRANS[inputData.initData.MMT.value].trans)+' / 5';

            data[9].keyTitle = that.$t(`unit.aRom.name`)+`(${ that.moment(inputData.lastData.aRom.date).locale(that.$t('country')).format('ll') })`;
            data[9].values = inputData.lastData.aRom.value+that.$t('unit.deg');
            data[10].keyTitle = that.$t(`unit.pRom.name`)+`(${ that.moment(inputData.lastData.pRom.date).locale(that.$t('country')).format('ll') })`;
            data[10].values = inputData.lastData.pRom.value+that.$t('unit.deg');
            data[11].keyTitle = that.$t(`unit.MMT.name`)+`(${ that.moment(inputData.lastData.MMT.date).locale(that.$t('country')).format('ll') })`;
            data[11].values = that.$t(MMT_GRADE_TRANS[inputData.lastData.MMT.value].trans)+' / 5';
            return data;
        },
    }
})()

export const _REHABILITATION_ITEMS_TEMPLATE = {
    seqMedicalRelation : 0,
    seqDeviceType : 0,
    position : 0,
    direction : 0,
    searchDate : {
        start : undefined,
        end : undefined
    },
    initData: {
        aRom: {
            date: undefined,
            value: 0,
        },
        pRom: {
            date: undefined,
            value: 0,
        },
        MMT: {
            date: undefined,
            value: 0,
        }
    },
    lastData: {
        aRom: {
            date: undefined,
            value: 0,
        },
        pRom: {
            date: undefined,
            value: 0,
        },
        MMT: {
            date: undefined,
            value: 0,
        }
    },
}